module.exports = __webpack_public_path__ + "static/media/checkBox_checked.84128b4d.svg";